document.addEventListener("DOMContentLoaded", function () {
    // 📌 Inicializar WaveSurfer para la pista principal
    const wavesurfer = WaveSurfer.create({
        container: "#waveform",
        waveColor: "white",
        progressColor: "#e04e74",
        cursorColor: "transparent",
        barWidth: 2,
        responsive: true,
        height: 80,
        backend: 'MediaElement',
        preload: 'auto',
        autoplay: false
    });

    // Precargar la pista principal
    wavesurfer.load("https://cdn.shopify.com/s/files/1/0914/1387/2946/files/mashup_bundle_temptation.mp3?v=1755113874");

    // Botón Play/Pause principal
    const playPauseBtn = document.getElementById("playPauseBtn");
    playPauseBtn.addEventListener("click", () => {
        if (wavesurfer.isPlaying()) {
            wavesurfer.pause();
            playPauseBtn.textContent = "▶";
        } else {
            wavesurfer.play();
            playPauseBtn.textContent = "⏸";
        }
    });

    // 🔥 Lista de muestras de audio con precarga mejorada
    const samples = [
        { id: "waveform1", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/wishes.mp3?v=1755037255" },
        { id: "waveform2", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Superficial.mp3?v=1755037254" },
        { id: "waveform3", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Alone.mp3?v=1755037255" },
        { id: "waveform4", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/A_Life_Together.mp3?v=1755037254" },
        { id: "waveform5", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Thoughts.mp3?v=1755037254" },
        { id: "waveform6", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/In_My_Dreams.mp3?v=1755037254" },
        { id: "waveform7", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/prickle.mp3?v=1755037254" },
        { id: "waveform8", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/ache.mp3?v=1755037254" },
        { id: "waveform9", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/pain.mp3?v=1755037255" },
        { id: "waveform10", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Dreaming_of_You.mp3?v=1755037254" },
        { id: "waveform11", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/flutter.mp3?v=1755037254" },
        { id: "waveform12", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/softness.mp3?v=1755037254" },
        { id: "waveform13", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/craving.mp3?v=1755037254" },
        { id: "waveform14", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/goosebumps.mp3?v=1755037254" },
        { id: "waveform15", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Kick_Bella.wav?v=1755037321" },
        { id: "waveform16", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_808_Soul_C_9703ac32-e763-4406-8c27-18f7cbae4ba1.wav?v=1755037313" },
        { id: "waveform17", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PHRASE_Another_Space_-_83_BPM_D_Min.mp3?v=1741880428" },
        { id: "waveform18", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PHRASE_Silhouette_-_74_BPM_F_Min.mp3?v=1741880428" },
        { id: "waveform19", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PHRASE_Moon_-_80_BPM_A_Min.mp3?v=1741880428" },
        { id: "waveform20", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PHRASE_Baby_-_97_BPM_C_Min.wav?v=1755101210" },
        { id: "waveform21", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_KEYS_Start_C.mp3?v=1741884138" },
        { id: "waveform22", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_LEAD_Water_C.mp3?v=1741884138" },
        { id: "waveform23", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_REESE_Simulation_C.mp3?v=1741884138" },
        { id: "waveform24", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_LEAD_Jupiter_C.wav?v=1755101556" },
        { id: "waveform25", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Neon_MIDI_-_G_Maj.mp3?v=1741874140" },
        { id: "waveform26", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Obsession_MIDI_-_F_Maj.mp3?v=1741874139" },
        { id: "waveform27", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Passion_MIDI_-_A_Min.mp3?v=1741874139" },
        { id: "waveform39", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/MUESTRA_1_DRUM_KIT.wav?v=1750973656" },
        { id: "waveform40", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/MUESTRA_3_DRUMS.mp3?v=1750973602" },
        { id: "waveform41", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Rimshot_Pour.wav?v=1752594273" },
        { id: "waveform42", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Clap_Love.wav?v=1752594280" },
        { id: "waveform43", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_LEAD_Urgency_C.wav?v=1750900506" },
        { id: "waveform44", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_LEAD_Taste_C.wav?v=1750900596" },
        { id: "waveform45", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_KEYS_Flirtation_C.wav?v=1750900712" },
        { id: "waveform46", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PLUCK_Amour_C.wav?v=1755040024" },
        { id: "waveform47", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Hearthrob_MIDI_-_G_Min_KEYS_Forbidden.wav?v=1750895454" },
        { id: "waveform48", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Bliss_MIDI_-_D_Min_KEYS_Vice.wav?v=1750895454" },
        { id: "waveform49", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Devoted_MIDI_-_F_Min_KEYS_Tease.wav?v=1750895454" },
    ];

    const wavesurfers = {};

    // 📌 Inicializar WaveSurfer para todos los samples
    samples.forEach(sample => {
        wavesurfers[sample.id] = WaveSurfer.create({
            container: `#${sample.id}`,
            waveColor: "white",
            progressColor: "#e04e74",
            cursorColor: "transparent",
            barWidth: 2,
            responsive: true,
            height: 40,
            backend: 'MediaElement',
            preload: 'auto'
        });

        // ✅ Cargar la forma de onda de una vez
        wavesurfers[sample.id].load(sample.file);
    });

    // 🎵 Botones de reproducción
    document.querySelectorAll(".play-btn").forEach(btn => {
        btn.addEventListener("click", function () {
            const sampleContainer = this.closest(".sample");
            const waveformDiv = sampleContainer.querySelector(".waveform");
            const waveformId = waveformDiv.id;

            if (wavesurfers[waveformId].isPlaying()) {
                wavesurfers[waveformId].pause();
                this.textContent = "▶";
            } else {
                // Pausar todos los demás
                Object.keys(wavesurfers).forEach(id => wavesurfers[id].pause());
                document.querySelectorAll(".play-btn").forEach(b => (b.textContent = "▶"));

                wavesurfers[waveformId].play();
                this.textContent = "⏸";
            }
        });
    });

    // 📌 Función para abrir y cerrar preguntas frecuentes (FAQ)
    document.querySelectorAll(".faq-question").forEach(btn => {
        btn.addEventListener("click", function () {
            const answer = this.nextElementSibling;
            const toggleSign = this.querySelector(".faq-toggle");

            if (answer.style.maxHeight) {
                answer.style.maxHeight = null;
                answer.style.opacity = "0";
                toggleSign.textContent = "+";
            } else {
                // Cerrar todas las demás preguntas antes de abrir una
                document.querySelectorAll(".faq-answer").forEach(ans => {
                    ans.style.maxHeight = null;
                    ans.style.opacity = "0";
                });
                document.querySelectorAll(".faq-toggle").forEach(sign => (sign.textContent = "+"));

                answer.style.maxHeight = answer.scrollHeight + "px";
                answer.style.opacity = "1";
                toggleSign.textContent = "-";
            }
        });
    });
});
